import { get, post } from './axiosConfig.js';
// import apiURL from './apiURL.js';
import simulation from '../../local_data/virtual_data.js';
let debug = false;
let ip = debug ? 'http://101.132.33.114:7204/v2' : 'https://hbhyx.rayplus.com/tk/v2'

export default {
	getHomeData() {
		// return get(apiURL.getHomeData)
		let data = simulation.getHomeData.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getGroupList() {
		// return get(apiURL.getGroupList)
		let data = simulation.getGroupList.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getAllExpertListByLimit(params) {
		// return post(apiURL.getAllExpertListByLimit, params)
		let data = simulation.getAllExpertListByLimit.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getExperteDetails(params) {
		// return post(apiURL.getExperteDetails, params)
		let data = simulation.getExperteDetails.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getSectionIntroduction() {
		// return get(apiURL.getSectionIntroduction)
		let data = simulation.getSectionIntroduction.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getAllArticleListByLimit(params) {
		function compare(key) {
			return function (value1, value2) {
				return value2[key].localeCompare(value1[key]);
			}
		}
		// return get(apiURL.getClinicalData)
		// console.log(simulation.getAllArticleListByLimit)
		simulation.getAllArticleListByLimit.data.data.data.sort(compare('time'))
		// return post(apiURL.getAllArticleListByLimit, params)
		let data = simulation.getAllArticleListByLimit.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getClinicalDataList(body) {
		let data = [];
		if(body && body.youth){
			data = simulation.getYouthList.data;
		}else{
			data = simulation.getClinicalDataList.data;
		}
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getSpecialTopicList() {
		// return get(apiURL.getSpecialTopicList)
		let data = simulation.getSpecialTopicList.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getVideoListByLimit(params) {
		// return post(apiURL.getVideoListByLimit)
		let data = simulation.getVideoListByLimit.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getVideoDataByVideoId(params) {
		// return post(apiURL.getVideoDataByVideoId)
		let data = simulation.getVideoDataByVideoId.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getAllActivityListByLimit(params) {
		// return post(apiURL.getAllActivityListByLimit)
		let data = simulation.getAllActivityListByLimit.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getArticleDtails(params) {
		// return post(apiURL.getArticleDtails)
		let data = simulation.getArticleDtails.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getCaseDetailsData(params) {
		// return post(apiURL.getCaseDetailsData)
		let data = simulation.getCaseDetailsData.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getRadiateDataList(params) {
		let data = simulation.getRadiateDataList.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getQcDataList(params) {
		let data = simulation.getQcDataList.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	getMemberList(params) {
		let data = simulation.getMemberList.data;
		return new Promise((resolve) => {
			resolve(data);
		})
	},
	// 获取视频
	getVideos(para) {
		return get(`${ip}/video`, para)
	}
}
